import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import { articlePageMatchPath, userPendingPostArticlePath } from '@ms/yammer-web-support/dist/urls';
import type { FC } from 'react';
import React from 'react';
import { Route, Switch } from 'react-router-dom';

const LazyArticleFooter = lazyLoadOnRender({
  loader: () =>
    import(/* webpackChunkName: "4-page-articlefooter" */ '@ms/yammer-web-components/dist/articles/ArticleFooter'),
});

const LoadableArticleFooter: FC = () => (
  <Switch>
    <Route exact={true} path={[articlePageMatchPath, userPendingPostArticlePath]}>
      <LazyArticleFooter />
    </Route>
  </Switch>
);

export default LoadableArticleFooter;
